import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Ruta_Asignaturas } from 'generated/graphql';

const initialState: Ruta_Asignaturas[] = [];

const rutaSesionesAsignaturasCachedStateSlice = createSlice({
	name: 'rutaSesionesAsignaturasCachedState',
	initialState,
	reducers: {
		setRutaSesionesAsignaturasCachedState: (state, action: PayloadAction<Ruta_Asignaturas[]>) => {
			return action.payload;
		}
	}
});

export const { setRutaSesionesAsignaturasCachedState } = rutaSesionesAsignaturasCachedStateSlice.actions;

export default rutaSesionesAsignaturasCachedStateSlice.reducer;
